import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isModalTarget} from './modal/target';
import {isPopoverTarget} from './popover/target';

export const isOverlayTarget = (element: ExpressionElement): boolean =>
  isPopoverTarget(element) || isModalTarget(element);
